import React, { useState, useEffect, useContext } from "react";
import AximDropdown from "components/Dropdown/AximDropdown";
import { Box } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { employeeApiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";

import { Utils } from "common/Utils";
import moment from "moment";

export default function ExcessAllocation () {
    const [payoutTypeDropdown, setPayoutTypeDropdown] = useState([]);
    const [payoutYearDropdown, setPayoutYearDropdown] = useState([]);
    const [payoutTypeSelected, setPayoutTypeSelected] = useState(null);
    const [payoutYearSelected, setPayoutYearSelected] = useState(null);

    const [payouts, setPayouts] = useState([]);
    const [hasInitializationError, setHasInitializationError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        apiGet(employeeApiUrls.getPayoutTypes).then((response) => {
            setPayoutTypeDropdown(response.data.map(hb => hb.payoutTypeCode).filter(Utils.onlyUnique))
            setPayoutYearDropdown(response.data.map(hb => hb.year).filter(Utils.onlyUnique))

        })
            .catch(e => {
                console.log(e);
                setHasInitializationError(true);
            });

    }, [])

    useEffect(() => {
        if (payoutTypeDropdown && payoutTypeDropdown.length > 0) {
            setPayoutTypeSelected(payoutTypeDropdown[0]);
        }
    },[payoutTypeDropdown]);

    useEffect(() => {
        if (payoutYearDropdown && payoutYearDropdown.length > 0) {
            setPayoutYearSelected(payoutYearDropdown[0]);
        }
    },[payoutYearDropdown]);

    useEffect(() => {
        loadPayoutData(payoutTypeSelected, payoutYearSelected);
    },[payoutTypeSelected, payoutYearSelected]);

    const loadPayoutData = () => {
        if (payoutTypeSelected && payoutYearSelected) {
            apiGet(employeeApiUrls.getPayouts(payoutTypeSelected, payoutYearSelected + '-01-01', payoutYearSelected + '-12-31'))
            .then((response) => {
                setPayouts(response.data)
                setIsLoading(false)
            })
            .catch(e => {
                console.log(e);
                setHasInitializationError(true);
            });
        }
    }

    const columns = [
        {
            Header: "Date",
            accessor: "payPeriodName"
        },
        {
            Header: "Payout Amount",
            accessor: "currentPayout",
            accessor: (cell) => Utils.formatCurrency(cell.currentPayout),
            canFilter: false
        },
        {
            Header: "Retro Amount",
            accessor: "retroAmount",
            accessor: (cell) => Utils.formatCurrency(cell.retroAmount),
            canFilter: false
        },
        {
            Header: "Recoup Amount",
            accessor: "recoupAmount",
            accessor: (cell) => Utils.formatCurrency(cell.recoupAmount),
            canFilter: false
        },
        {
            Header: "Actual Payout Amount",
            accessor: "actualPayAmount",
            accessor: (cell) => Utils.formatCurrency(cell.actualPayAmount),
            canFilter: false
        }
    ];

    return (
        <Box className={TableStyle.tableWrapper}>
            <Box className={"d-flex justify-content-start"}>
                {payoutTypeDropdown === null ? <LoaderAnimation /> :
                    payoutTypeDropdown.length > 0 ? (
                        <>
                            <AximDropdown
                                label="Payout Type"
                                handleChange={(e) => {
                                    setPayoutTypeSelected(e.target.value)
                                }}
                                value={payoutTypeSelected}
                                pairs={payoutTypeDropdown.map(ht => ({ value: ht, text: ht }))} />

                            <AximDropdown
                                label="Year"
                                handleChange={(e) => {
                                    setPayoutYearSelected(e.target.value)
                                }}
                                value={payoutYearSelected}
                                pairs={payoutYearDropdown.map(ht => ({ value: ht, text: ht }))} />
                        </>
                    ) : (
                        ""
                    )}
            </Box>
            <Box>
                {hasInitializationError ? <h4>Error Loading payout</h4> :
                    payouts === null ? <LoaderAnimation /> :
                        payouts.length === 0 ? <h5 className="text-center mb-4">No payout to display</h5> :
                            <Box className="container-fluid">
                                <Box className="row justify-content-center">
                                    <TableAllData columns={columns} data={payouts} isLoading={isLoading} hidePagination={true} />
                                </Box>
                            </Box>
                }
            </Box>
        </Box>
    )
}
